import React from "react";
import "./Group2.css";

function Group2() {
  return (
    <div className="group-2">
      <div className="united-states-1">
        <div className="overlap-group-7">
          <div className="group">
            <img className="vector-18" src="/img/vector-5@1x.png" />
            <img className="vector-19" src="/img/vector-4@1x.png" />
            <img className="vector-20" src="/img/vector-7@1x.png" />
            <img className="vector-21" src="/img/vector-6@1x.png" />
          </div>
          <img className="vector-22" src="/img/vector-3@1x.png" />
        </div>
      </div>
      <div className="eng-us avenir-black-eerie-black-16px">ENG (US)</div>
      <img className="arrow-1" src="/img/arrow-1@1x.png" />
    </div>
  );
}

export default Group2;
